var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.63 0H4a4 4 0 00-4 4v33a4 4 0 004 4h15.63a4 4 0 004-4V4a4 4 0 00-4-4zM1 8h21.61v25H1zm3-7h15.63a3 3 0 013 3v3H1V4a3 3 0 013-3zm15.63 39H4a3 3 0 01-3-3v-3h21.61v3a3 3 0 01-2.98 3z","key":0}),React.createElement("path",{"d":"M7.46 4.48h8.7a.5.5 0 000-1h-8.7a.5.5 0 000 1z","key":1}),React.createElement("circle",{"cx":"11.8","cy":"37.02","r":"1.13","key":2})]);
}

Phone.defaultProps = {"viewBox":"0 0 23.61 41"};

module.exports = Phone;

Phone.default = Phone;
